module.exports = __webpack_public_path__ + "static/media/new_disable.3b8d240f.svg";